module.exports = __webpack_public_path__ + "img/images/new-landing/man.png?92365671";